import React from 'react';
import ReactDOM from 'react-dom';

import FormItemConst from '../../formItem/FormItemConst';
import GOTPropertiesUtil from '../../utils/GOTPropertiesUtil';
import DialogValue from './remote/DialogValue';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';

require("bootstrap-select");
require("bootstrap-select/dist/css/bootstrap-select.css");
require("../../styles/FormItemEnumStyle.css");



export default class DialogFieldEnumEditor extends React.Component
{
	constructor(props) {
		super(props);
		let _data = Object.assign({},this.props.data);
		let _properties;
		try
		{
			_properties = GOTPropertiesUtil.getItemPropertyFinalValue(null,_data.entityId,null);
		}
		catch(e)
		{
			alert("类型为Enum的DialogField可能未填写正确的entityId,它必须指向一个Enum或者Enum类型的DataType");
		}
		if(_properties)
		{
			_data.options = _properties.DataProvider;	
		}
		else
		{
			_data.options = [];
			alert("类型为Enum的DialogField必须指向一个Enum或者Enum类型的DataType");
		}
		
		this.state = {data:_data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	componentDidMount()
	{
		let displayLength=this.state.data.displayLength;
		if(displayLength == 0)displayLength = 10;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+20+'px';
		$(this.inputField).selectpicker({width:_width,noneSelectedText: '未选中',noneResultsText: '没有找到匹配项'});
	}

	componentDidUpdate()
  	{
		if(this.state.allowEdit == false)
		{
			let $dom = $(this.inputField).parent().find("button.btn");
			$dom.css("background-color",FormItemConst.EDITOR_NOTEDIT_COLOR).css("cursor","not-allowed");
			$(this.inputField).attr("disabled","");
		}
		else
		{
			let $dom = $(this.inputField).parent().find("button.btn");
			$dom.css("cursor","pointer");
			$(this.inputField).removeAttr("disabled");
		}
  	}

  	componentWillUnmount()
	{
		this.unsubscribeDiaLogMapEditorsStore();
	}

	render()
	{
		let _options = this.state.data.options;
		let _defaultValue = this.state.data.defaultValue;
		let list = _options.map(function(item){
			let _value = item.value;
			if(_defaultValue && _defaultValue == _value)
				return <option key={_value} value={_value} selected="selected">{item.label}</option>;
			return <option key={_value} value={_value}>{item.label}</option>;
		});
		
		let notNull=this.state.data.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center',fontSize:"12px"};

		return(
			<div id={"EditorDialog"+this.state.data.id} className='editorGroup' style={editorStyle}>
			  <label htmlFor={"select"+this.state.data.id} className="fieldGroupLabel"
			  		 style={{paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'}}>
			  		 {this.state.data.label}
			  		 
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
	          <select className="selectpicker form-control" data-live-search="true" ref={ node => this.inputField = node } id={"select"+this.state.data.id} style={{padding:'2px !important',height:FormItemConst.EDITOR_HEIGHT+'px'}}>
                  {list}
              </select>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldEnumEditor.js